const ArrowDown = ({ color }: { color: string }) => {
    return (
        <svg width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">

            <path d="M7.25 0.499999H8.75V12.625L14.45 6.925L15.5 8L8 15.5L0.5 8L1.55 6.925L7.25 12.625V0.499999Z" fill={color} />

        </svg>

    )
}

export default ArrowDown
